import type { PropsWithChildren } from 'react'
import { createPortal } from 'react-dom'
import { useIsMobile } from '@cocoonspace/ui/hooks/use-mobile'
import { cn } from '@cocoonspace/ui/lib/utils'
import dynamic from 'next/dynamic'

interface StickyContentFooterProps {
	className?: string
}

export const StickyContentFooter = dynamic(
	() => Promise.resolve(StickyContentFooterImpl),
	{ ssr: false },
)

const StickyContentFooterImpl = ({
	children,
	className,
}: PropsWithChildren<StickyContentFooterProps>) => {
	const isMobile = useIsMobile()

	const mainContent = document.getElementById('main-content')

	if (!isMobile) {
		return <div className={className}>{children}</div>
	}

	if (!mainContent) {
		console.warn('StickyContentFooter: #main-content not found')
		return null
	}

	return createPortal(
		<div className={cn('sticky bottom-0', className)}>{children}</div>,
		mainContent,
	)
}
